import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../utils/api';
import { X, Send, FileText } from 'lucide-react';
import toast from 'react-hot-toast';

function SendReportsModal({ row, onClose }) {
  const queryClient = useQueryClient();
  const [sentTo, setSentTo] = useState('');

  const sendMutation = useMutation({
    mutationFn: async () => {
      const res = await api.post(`/jobs/${row.job_id}/send-reports`, { sentTo: sentTo || null });
      return res.data;
    },
    onSuccess: (data) => {
      toast.success(data.message || 'Reports sent');
      queryClient.invalidateQueries(['repairs']);
      onClose();
    },
    onError: (err) => {
      toast.error(err.response?.data?.error || 'Failed to send reports');
    },
  });

  const isAnnual = row.inspection_type === 'ANNUAL';
  const reportDesc = isAnnual
    ? 'Inspection Report + Detection Report'
    : 'Detection Report only';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-card rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="flex items-center justify-between p-6 border-b">
          <div className="flex items-center gap-2">
            <FileText className="w-6 h-6 text-primary-600" />
            <h2 className="text-xl font-bold text-gray-900">Send Reports</h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-6 h-6" />
          </button>
        </div>
        <div className="p-6 space-y-4">
          <p className="text-sm text-gray-600">
            {row.building_name} · {row.ss_code} {row.ss_name}
          </p>
          <p className="text-sm text-gray-600">
            <span className="font-medium">Reports to send:</span> {reportDesc}
          </p>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Recipient (optional)</label>
            <input
              type="text"
              value={sentTo}
              onChange={(e) => setSentTo(e.target.value)}
              placeholder="Building owner email or name"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500"
            />
          </div>
        </div>
        <div className="flex justify-end gap-2 p-6 border-t">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg"
          >
            Cancel
          </button>
          <button
            onClick={() => sendMutation.mutate()}
            disabled={sendMutation.isLoading}
            className="flex items-center px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50"
          >
            <Send className="w-4 h-4 mr-2" />
            {sendMutation.isLoading ? 'Sending...' : 'Send Reports'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SendReportsModal;
